import type { FC } from 'react';
import { FormattedMessage, injectIntl, type IntlShape } from 'react-intl';
import styled from 'styled-components';
import { to } from 'routing/to';

import { LinkHrefStyled } from '../../components/link-styled';

interface FooterWrapperProps {
  dashboard: boolean;
}

const FooterWrapper = styled.div<FooterWrapperProps>`
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: right;
  padding: ${(props) =>
    props.dashboard ? '10px 10px 20px' : '10px 10px 50px'};

  @media screen and (min-width: ${(props) => props.theme.xsmall}) {
    text-align: left;
    padding: 10px 20px 10px;
  }
`;

const Privacy = styled.div`
  @media screen and (min-width: ${(props) => props.theme.small}) {
    position: relative;
    right: 50%;
    transform: translateX(50%);
    float: right;
  }
`;

export interface ShopCollection {
  readonly size: number;
}

export interface DashboardFooterProps {
  shops: ShopCollection;
  path?: string;
  intl: IntlShape;
}

interface LegacyFooterComponent extends FC<DashboardFooterProps> {
  defaulProps?: {
    shops: readonly never[];
  };
}

const privacyMessage = {
  id: 'containers.Dashboard.Footer.privacyPolicy',
  defaulMessage: 'Privacy Policy',
};

export const Footer: LegacyFooterComponent = ({ shops, path, intl }) => {
  const generateUrl = (german: string, english?: string) => {
    const url = {
      de: german,
      en: `en/${english || german}`,
    }[intl.locale];
    return `https://uptain.de/${url}/`;
  };

  return (
    <FooterWrapper dashboard={path === to.root || shops.size <= 1}>
      <Privacy>
        <LinkHrefStyled
          href={generateUrl('datenschutz', 'privacy-policy')}
          target="_blank"
          color="#EFEFEF"
        >
          <FormattedMessage {...privacyMessage} />
        </LinkHrefStyled>
      </Privacy>
    </FooterWrapper>
  );
};

Footer.defaulProps = {
  shops: [],
};

export default injectIntl(Footer);
